import React from "react";
import { FormattedMessage } from "react-intl";

import { PersonName } from "~/components/common/PersonName";
import { selectInstructions } from "~/slices/instructions";
import { useAppSelector } from "~/store";

import {
  RedesignPatientActionCard,
  shouldUseRedesignPatientNotification,
} from "./patient-action-notification";

export function saveDraftPatientNotification() {
  return <SaveDraftNotification />;
}

function SaveDraftNotification() {
  const instructions = useAppSelector(selectInstructions);

  if (shouldUseRedesignPatientNotification()) {
    return (
      <RedesignPatientActionCard
        testId="rd-notify-patient-draft"
        title={
          <>
            <FormattedMessage id="notify.patient.create.draft.patient" />
            <PersonName person={instructions} />
            <FormattedMessage id="notify.patient.create.draft.ok" />
          </>
        }
      />
    );
  }

  return (
    <div style={{ borderRadius: "8px !important", visibility: "visible" }} className="wpb-popup-wr">
      <div className="wpb-popup wpb-popup--small">
        <a
          style={{ width: "10px", height: "10px", top: "4px", right: "8px", opacity: "0.8" }}
          href="#"
          className="wpb-popup__close"
        ></a>
        <div className="wpb-popup__body">
          <FormattedMessage id="notify.patient.create.draft.patient" />
          <PersonName person={instructions} />
          <FormattedMessage id="notify.patient.create.draft.ok" />
        </div>
      </div>
    </div>
  );
}
